<template>
  <div :class="flowViewClass">
    <template v-for="(step, index) in getStepList()">
      <div class="flow-step d-flex justify-content-between align-items-center" :class="getStepClass(index)"
           :key="index">
        <div class="flow-step-image d-flex justify-content-center align-items-center" :class="getStepClass(index)"
             v-html="step.svgImage">
        </div>
        <div class="flow-step-info">
          <span v-if="step.link" v-html="step.info" @click="$router.push(step.link)"> </span>
          <span v-else v-html="step.info"> </span><span v-if="step.time">  {{step.time}}</span>
        </div>
        <div class="flow-step-status-icon d-flex justify-content-center align-items-center">
          <template v-if="getStepClass(index) === 'active'">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="8" transform="rotate(-180 8 8)" fill="#FFA800"/>
              <rect width="1" height="7" rx="0.5" transform="matrix(1.74846e-07 -1 -1 -1.74846e-07 11.5 8.5)"
                    fill="white"/>
              <path
                  d="M8.35355 10.6464C8.54882 10.8417 8.54882 11.1583 8.35355 11.3536C8.15829 11.5488 7.84171 11.5488 7.64645 11.3536L4.64645 8.35355C4.45716 8.16426 4.45054 7.85947 4.63142 7.66214L7.38142 4.66214C7.56802 4.45858 7.88431 4.44483 8.08786 4.63142C8.29142 4.81802 8.30518 5.1343 8.11858 5.33786L5.69207 7.98496L8.35355 10.6464Z"
                  fill="white"/>
            </svg>
          </template>
          <template v-else-if="getStepClass(index) === 'done'">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="8" fill="#1BC5BD"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10.8847 5.21735C11.0247 5.07862 11.2136 5.00055 11.4106 5C11.6077 4.99946 11.7971 5.07649 11.9378 5.21445C12.0785 5.3524 12.1592 5.54019 12.1626 5.73722C12.166 5.93425 12.0916 6.12468 11.9557 6.26735L7.96371 11.2574C7.8951 11.3312 7.81229 11.3906 7.72024 11.4317C7.62819 11.4729 7.52878 11.4951 7.42796 11.4969C7.32714 11.4988 7.22698 11.4803 7.13347 11.4426C7.03995 11.4049 6.95501 11.3487 6.88371 11.2774L4.23871 8.63135C4.16502 8.56269 4.10592 8.47989 4.06493 8.38789C4.02394 8.29589 4.00189 8.19658 4.00012 8.09587C3.99834 7.99517 4.01686 7.89514 4.05459 7.80175C4.09231 7.70837 4.14845 7.62353 4.21967 7.55231C4.29089 7.48109 4.37572 7.42495 4.46911 7.38723C4.5625 7.34951 4.66253 7.33098 4.76323 7.33276C4.86393 7.33454 4.96325 7.35658 5.05525 7.39757C5.14725 7.43856 5.23005 7.49766 5.29871 7.57135L7.39271 9.66435L10.8657 5.23935C10.8719 5.2316 10.8786 5.22426 10.8857 5.21735H10.8847Z"
                    fill="white"/>
            </svg>
          </template>
          <template v-else>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="7.5" stroke="#B5B5C3"/>
            </svg>
          </template>
        </div>
      </div>
      <div class="arrow" hidden-xs v-if="flowView === 'row'" :key="'icon'+index">
        <svg width="29" height="10" viewBox="0 0 29 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect opacity="0.3" x="8.88867" y="5.74072" width="1.2963" height="5.83333" rx="0.648148"
                transform="rotate(-90 8.88867 5.74072)" fill="#B5B5C3"/>
          <rect opacity="0.3" x="17.7773" y="5.74072" width="1.2963" height="5.83333" rx="0.648148"
                transform="rotate(-90 17.7773 5.74072)" fill="#B5B5C3"/>
          <rect opacity="0.3" y="5.74072" width="1.2963" height="5.83333" rx="0.648148"
                transform="rotate(-90 0 5.74072)" fill="#B5B5C3"/>
          <path
              d="M23.5365 8.78064C23.2653 9.05958 23.2653 9.51184 23.5365 9.79079C23.8077 10.0697 24.2474 10.0697 24.5186 9.79079L28.6853 5.50508C28.9482 5.23466 28.9574 4.79925 28.7061 4.51734L24.8867 0.231629C24.6275 -0.0591698 24.1883 -0.0788155 23.9055 0.187751C23.6228 0.454317 23.6037 0.906151 23.8629 1.19695L27.233 4.97852L23.5365 8.78064Z"
              fill="#B5B5C3"/>
        </svg>
      </div>
    </template>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "LiquidityFlowSteps",
  props: {
    currentStep: Number,
    time1: Number,
    time2: Number,
    flowView: String,
    baseToken: Object,
  },

  data: function () {
    return {
      flowSteps: [
        {
          svgImage: '<svg width="31" height="24" viewBox="0 0 31 24"  xmlns="http://www.w3.org/2000/svg">\n' +
              '<g opacity="0.7">\n' +
              '<path opacity="0.5" d="M21.0829 0C17.5726 0 14.7246 2.8368 14.7246 6.33332C14.7246 9.82984 17.5726 12.6666 21.0829 12.6666C24.5932 12.6666 27.4412 9.82984 27.4412 6.33332C27.4412 2.8368 24.5932 0 21.0829 0ZM21.0829 10.4786C18.7703 10.4786 16.8937 8.60936 16.8937 6.30583C16.8937 4.00231 18.7703 2.1331 21.0829 2.1331C23.3955 2.1331 25.2721 4.00231 25.2721 6.30583C25.2721 8.60936 23.3955 10.4786 21.0829 10.4786Z"  />\n' +
              '<path d="M21.0841 9.33299C22.7475 9.33299 24.0959 7.98985 24.0959 6.333C24.0959 4.67615 22.7475 3.33301 21.0841 3.33301C19.4207 3.33301 18.0723 4.67615 18.0723 6.333C18.0723 7.98985 19.4207 9.33299 21.0841 9.33299Z" />\n' +
              '<path opacity="0.3" d="M9.36914 6.35732C9.36914 9.47653 11.7817 11.9998 14.7525 11.9998C14.9728 11.9998 15.1777 11.9569 15.3877 11.93C13.7844 10.6415 12.7293 8.63364 12.7293 6.35195C12.7293 4.07026 13.7896 2.02478 15.3928 0.736297C15.1828 0.709453 14.9728 0.666504 14.7577 0.666504C11.7817 0.666504 9.36914 3.24348 9.36914 6.35732Z"  />\n' +
              '<path opacity="0.3" d="M10.0373 0.736297C9.82714 0.709453 9.61695 0.666504 9.40164 0.666504C6.42313 0.666504 4.01367 3.23811 4.01367 6.35732C4.01367 9.47653 6.42826 11.9998 9.40164 11.9998C9.62208 11.9998 9.82714 11.9569 10.0373 11.93C8.43272 10.6415 7.37666 8.63364 7.37666 6.35195C7.38179 4.08099 8.43272 2.02478 10.0373 0.736297Z"  />\n' +
              '<path d="M27.8504 16.135C27.8445 16.135 27.8445 16.141 27.8327 16.141L22.862 18.5333C22.9153 18.8166 22.9389 19.0938 22.933 19.383C22.9271 19.6783 22.6904 19.9133 22.3945 19.9133C22.3886 19.9133 22.3886 19.9133 22.3768 19.9133L15.1042 19.7084C14.8084 19.7024 14.5776 19.4493 14.5835 19.148C14.5894 18.8467 14.8379 18.6117 15.1338 18.6177L21.8146 18.8045C21.5898 17.4848 20.4891 16.5146 19.1754 16.4724L14.7492 16.3459C13.8793 16.3218 13.0213 16.0988 12.2461 15.683L11.7964 15.448C9.58324 14.2789 6.92631 14.4296 4.86112 15.8457L4.68359 22.396L5.44103 21.9803C6.19846 21.5645 7.08016 21.468 7.90861 21.7091L15.4119 23.8544C16.8558 24.1557 18.3588 23.9869 19.708 23.3662L30.1168 16.5146C29.5251 15.8999 28.6079 15.7433 27.8504 16.135Z"  />\n' +
              '<path opacity="0.5" d="M0 23.8899L0.258703 14L4.01577 14.1101L3.75707 24L0 23.8899Z" />\n' +
              '</g>\n' +
              '</svg>\n',
          info: `<span class="simple-link text-info">Invest in pools with ${this.baseToken ? this.baseToken.symbol : ""}</span><br> and go to this page`,
          link: '/liquidity',
        },
        {
          svgImage: '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">\n' +
              '<g opacity="0.7">\n' +
              '<path d="M0 25.2285C0 25.6554 0.339797 26 0.760739 26H25.2058C25.6268 26 25.9666 25.6554 25.9666 25.2285V19.7764H0V25.2285Z"/>\n' +
              '<path opacity="0.5" d="M3.09945 11.002L0.244141 18.2338H25.7188L22.8685 11.002C22.7519 10.7089 22.4729 10.5186 22.1636 10.5186H19.0293C17.6397 12.3805 15.4589 13.6047 12.984 13.6047C10.509 13.6047 8.32826 12.3805 6.93865 10.5186H3.8044C3.49503 10.5186 3.2161 10.7089 3.09945 11.002ZM6.89807 15.1477H19.0699C19.4908 15.1477 19.8306 15.4923 19.8306 15.9192C19.8306 16.3462 19.4908 16.6908 19.0699 16.6908H6.89807C6.47713 16.6908 6.13733 16.3462 6.13733 15.9192C6.13733 15.4923 6.47713 15.1477 6.89807 15.1477Z" />\n' +
              '<path opacity="0.3" d="M13.1376 0C9.77609 0 7.04883 2.76594 7.04883 6.17511C7.04883 9.58429 9.77609 12.3502 13.1376 12.3502C16.4991 12.3502 19.2264 9.58429 19.2264 6.17511C19.2264 2.76594 16.4991 0 13.1376 0ZM13.1376 10.2168C10.923 10.2168 9.12599 8.39429 9.12599 6.14831C9.12599 3.90233 10.923 2.07981 13.1376 2.07981C15.3522 2.07981 17.1492 3.90233 17.1492 6.14831C17.1492 8.39429 15.3522 10.2168 13.1376 10.2168Z" />\n' +
              '<path d="M13.14 9.10059C14.7329 9.10059 16.0242 7.791 16.0242 6.17554C16.0242 4.56008 14.7329 3.25049 13.14 3.25049C11.5471 3.25049 10.2559 4.56008 10.2559 6.17554C10.2559 7.791 11.5471 9.10059 13.14 9.10059Z" />\n' +
              '</g>\n' +
              '</svg>',
          info: 'Enter the pool <br>and make a deposit'
        },
        {
          svgImage: '<svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0ZM2 11C2 9.8181 2.23279 8.64778 2.68508 7.55585C3.13738 6.46392 3.80031 5.47177 4.63604 4.63604C5.47177 3.80031 6.46392 3.13738 7.55585 2.68508C8.64778 2.23279 9.8181 2 11 2C12.1819 2 13.3522 2.23279 14.4442 2.68508C15.5361 3.13738 16.5282 3.80031 17.364 4.63604C18.1997 5.47177 18.8626 6.46392 19.3149 7.55585C19.7672 8.64778 20 9.8181 20 11C20 13.3869 19.0518 15.6761 17.364 17.364C15.6761 19.0518 13.3869 20 11 20C8.61305 20 6.32387 19.0518 4.63604 17.364C2.94821 15.6761 2 13.3869 2 11ZM12 6C12 5.73478 11.8946 5.48043 11.7071 5.29289C11.5196 5.10536 11.2652 5 11 5C10.7348 5 10.4804 5.10536 10.2929 5.29289C10.1054 5.48043 10 5.73478 10 6V11C10 11.1552 10.0361 11.3084 10.1056 11.4472C10.175 11.5861 10.2758 11.7069 10.4 11.8L14.4 14.8C14.6122 14.9591 14.8789 15.0275 15.1414 14.99C15.404 14.9524 15.6409 14.8122 15.8 14.6C15.9591 14.3878 16.0275 14.1211 15.99 13.8586C15.9524 13.596 15.8122 13.3591 15.6 13.2L12 10.5V6Z" />\n' +
              '</svg>\n',
          info: '<span class="text-muted">Wait until </span> ',
          time: '',
        },
        {
          svgImage: '<svg width="24" height="24" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M2.7793 14.0059V21.0132H9.81421V14.0059H2.7793ZM8.90846 19.1124L7.91478 20.1022L6.29675 18.4993L4.68752 20.1022L3.69384 19.1124L5.30307 17.5095L3.69384 15.9066L4.68752 14.9168L6.29675 16.5197L7.90599 14.9168L8.89967 15.9066L7.29043 17.5095L8.90846 19.1124Z" "/>\n' +
              '<path d="M14.0352 2.79395V9.80124H21.0701V2.79395H14.0352ZM19.6631 6.99833H15.4421V5.59687H19.6631V6.99833Z" />\n' +
              '<path d="M2.7793 2.79395V9.80124H9.81421V2.79395H2.7793ZM8.40723 6.99833H7.00024V8.39979H5.59326V6.99833H4.18628V5.59687H5.59326V4.19541H7.00024V5.59687H8.40723V6.99833Z" />\n' +
              '<path d="M14.0352 14.0059V21.0132H21.0701V14.0059H14.0352ZM19.6631 19.6117H15.4421V18.2102H19.6631V19.6117ZM19.6631 16.8088H15.4421V15.4073H19.6631V16.8088Z" />\n' +
              '<path opacity="0.5" d="M21.8083 0H2.11048C0.949718 0 0 0.945985 0 2.10219V2.67153V21.3285V21.8978C0 23.054 0.949718 24 2.11048 24H21.8083C22.9691 24 23.9188 23.054 23.9188 21.8978V19.927V4.07299V2.10219C23.9188 0.945985 22.9691 0 21.8083 0ZM2.81398 1.40146H9.84893C10.5964 1.40146 11.2032 1.98832 11.2559 2.71533C11.2471 2.71533 11.2383 2.71533 11.2383 2.71533C11.2559 2.79416 11.2647 2.88175 11.2647 2.96934V9.81022C11.2647 10.581 10.6316 11.2117 9.85772 11.2117H2.82277C2.04893 11.2117 1.41578 10.581 1.41578 9.81022V2.96934C1.41578 2.86423 1.42458 2.75912 1.45096 2.66277C1.44216 2.66277 1.43337 2.66277 1.42458 2.66277C1.48613 1.95328 2.0841 1.40146 2.81398 1.40146ZM9.84893 22.5898H2.81398C2.0841 22.5898 1.48613 22.038 1.41578 21.3285C1.42458 21.3285 1.43337 21.3285 1.44216 21.3285C1.41578 21.2321 1.40699 21.127 1.40699 21.0219V14.181C1.40699 13.4102 2.04013 12.7796 2.81398 12.7796H9.84893C10.6228 12.7796 11.2559 13.4102 11.2559 14.181V21.0219C11.2559 21.1095 11.2471 21.1883 11.2295 21.2759C11.2383 21.2759 11.2471 21.2759 11.2471 21.2759C11.2032 22.0029 10.5964 22.5898 9.84893 22.5898ZM22.5118 21.1883C22.5118 21.9591 21.8787 22.5898 21.1048 22.5898H14.0699C13.3048 22.5898 12.6805 21.9766 12.6629 21.2146C12.6717 21.2146 12.6717 21.2146 12.6805 21.2146C12.6717 21.1533 12.6629 21.092 12.6629 21.0219V14.181C12.6629 13.4102 13.2961 12.7796 14.0699 12.7796H21.1048C21.8787 12.7796 22.5118 13.4102 22.5118 14.181V20.1022V21.1883ZM22.5118 9.81022C22.5118 10.581 21.8787 11.2117 21.1048 11.2117H14.0699C13.2961 11.2117 12.6629 10.581 12.6629 9.81022V2.96934C12.6629 2.90803 12.6717 2.83796 12.6805 2.77664C12.6717 2.77664 12.6717 2.77664 12.6629 2.77664C12.6805 2.0146 13.3048 1.40146 14.0699 1.40146H21.1048C21.8787 1.40146 22.5118 2.03212 22.5118 2.80292V3.88905V9.81022Z" />\n' +
              '</svg>\n',
          info: 'Go to this page and <br>Calculate LQF share'
        },
        {
          svgImage: '<svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0ZM2 11C2 9.8181 2.23279 8.64778 2.68508 7.55585C3.13738 6.46392 3.80031 5.47177 4.63604 4.63604C5.47177 3.80031 6.46392 3.13738 7.55585 2.68508C8.64778 2.23279 9.8181 2 11 2C12.1819 2 13.3522 2.23279 14.4442 2.68508C15.5361 3.13738 16.5282 3.80031 17.364 4.63604C18.1997 5.47177 18.8626 6.46392 19.3149 7.55585C19.7672 8.64778 20 9.8181 20 11C20 13.3869 19.0518 15.6761 17.364 17.364C15.6761 19.0518 13.3869 20 11 20C8.61305 20 6.32387 19.0518 4.63604 17.364C2.94821 15.6761 2 13.3869 2 11ZM12 6C12 5.73478 11.8946 5.48043 11.7071 5.29289C11.5196 5.10536 11.2652 5 11 5C10.7348 5 10.4804 5.10536 10.2929 5.29289C10.1054 5.48043 10 5.73478 10 6V11C10 11.1552 10.0361 11.3084 10.1056 11.4472C10.175 11.5861 10.2758 11.7069 10.4 11.8L14.4 14.8C14.6122 14.9591 14.8789 15.0275 15.1414 14.99C15.404 14.9524 15.6409 14.8122 15.8 14.6C15.9591 14.3878 16.0275 14.1211 15.99 13.8586C15.9524 13.596 15.8122 13.3591 15.6 13.2L12 10.5V6Z" />\n' +
              '</svg>\n',
          info: '<span class="text-muted">Wait until </span> ',
          time: '',
        },
        {
          svgImage: '<svg width="28" height="24" viewBox="0 0 28 24" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path opacity="0.5" d="M20.5133 4.18464C20.5133 2.9685 19.5297 1.98486 18.3136 1.98486H16.2867C16.2867 2.23524 16.2807 2.47966 16.2748 2.73004H16.2688V3.14735C16.2688 3.24869 16.2628 3.35003 16.2628 3.45138H16.2688V4.48867C16.2688 4.97155 15.8694 5.365 15.3805 5.365C14.8857 5.365 14.4923 4.97155 14.4923 4.48867V3.45138C14.4923 2.96254 14.5042 2.4737 14.5042 1.98486H6.02702V2.73004H6.02106V4.48867C6.02106 4.97155 5.62165 5.365 5.13281 5.365C4.63801 5.365 4.24455 4.97155 4.24455 4.48867V3.45138V1.98486H2.20574C0.9896 1.98486 0.00596147 2.9685 0.00596147 4.18464V6.41422H0V7.51113H20.5074V7.10575H20.5133V4.18464Z" />\n' +
              '<path d="M5.14518 5.04935C4.81134 5.04935 4.53711 4.77512 4.53711 4.44128V0.608068C4.53711 0.274227 4.81134 0 5.14518 0C5.47902 0 5.75324 0.274227 5.75324 0.608068V4.44128C5.75324 4.77512 5.47902 5.04935 5.14518 5.04935Z" />\n' +
              '<path d="M15.3503 5.04935C15.0164 5.04935 14.7422 4.77512 14.7422 4.44128V0.608068C14.7422 0.274227 15.0164 0 15.3503 0C15.6841 0 15.9583 0.274227 15.9583 0.608068V4.44128C15.9524 4.77512 15.6841 5.04935 15.3503 5.04935Z" />\n' +
              '<path opacity="0.3" d="M0.00585938 8.11963V17.6758C0.00585938 18.892 0.989498 19.8756 2.20563 19.8756H13.3953C13.2462 19.4046 13.1449 18.9158 13.0972 18.4091H2.20563C1.80026 18.4091 1.47238 18.0812 1.47238 17.6758V8.14944V17.6758C1.47238 18.0812 1.80026 18.4091 2.20563 18.4091H13.0972C13.0734 18.1706 13.0614 17.9262 13.0614 17.6758C13.0614 16.4835 13.3476 15.3628 13.8483 14.3672C13.896 14.2778 14.2537 13.6638 14.4803 13.3419C14.9095 12.7636 15.4162 12.245 15.9945 11.8157H14.7724C14.367 11.8157 14.0391 11.4878 14.0391 11.0825C14.0391 10.6771 14.367 10.3492 14.7724 10.3492H16.2329C16.6383 10.3492 16.9662 10.6771 16.9662 11.0825C16.9662 11.1242 16.9602 11.1659 16.9543 11.2017C17.9737 10.6592 19.1361 10.3552 20.3702 10.3552C20.4179 10.3552 20.4656 10.3552 20.5132 10.3552V8.11963H0.00585938ZM5.92558 17.6758H4.46502C4.05964 17.6758 3.73177 17.348 3.73177 16.9426C3.73177 16.5372 4.05964 16.2093 4.46502 16.2093H5.93154C6.33692 16.2093 6.6648 16.5372 6.6648 16.9426C6.65884 17.348 6.33096 17.6758 5.92558 17.6758ZM5.92558 14.7428H4.46502C4.05964 14.7428 3.73177 14.4149 3.73177 14.0095C3.73177 13.6042 4.05964 13.2763 4.46502 13.2763H5.93154C6.33692 13.2763 6.6648 13.6042 6.6648 14.0095C6.65884 14.4149 6.33096 14.7428 5.92558 14.7428ZM5.92558 11.8157H4.46502C4.05964 11.8157 3.73177 11.4878 3.73177 11.0825C3.73177 10.6771 4.05964 10.3492 4.46502 10.3492H5.93154C6.33692 10.3492 6.6648 10.6771 6.6648 11.0825C6.65884 11.4878 6.33096 11.8157 5.92558 11.8157ZM10.9928 17.6758H9.52629C9.12091 17.6758 8.79303 17.348 8.79303 16.9426C8.79303 16.5372 9.12091 16.2093 9.52629 16.2093H10.9928C11.3982 16.2093 11.7261 16.5372 11.7261 16.9426C11.7261 17.348 11.3982 17.6758 10.9928 17.6758ZM10.9928 14.7428H9.52629C9.12091 14.7428 8.79303 14.4149 8.79303 14.0095C8.79303 13.6042 9.12091 13.2763 9.52629 13.2763H10.9928C11.3982 13.2763 11.7261 13.6042 11.7261 14.0095C11.7261 14.4149 11.3982 14.7428 10.9928 14.7428ZM10.9928 11.8157H9.52629C9.12091 11.8157 8.79303 11.4878 8.79303 11.0825C8.79303 10.6771 9.12091 10.3492 9.52629 10.3492H10.9928C11.3982 10.3492 11.7261 10.6771 11.7261 11.0825C11.7261 11.4878 11.3982 11.8157 10.9928 11.8157Z" />\n' +
              '<path opacity="0.5" d="M20.7213 11.4287C17.2484 11.4287 14.4355 14.2415 14.4355 17.7145C14.4355 21.1874 17.2484 24.0002 20.7213 24.0002C24.1942 24.0002 27.0071 21.1874 27.0071 17.7145C27.0071 14.2415 24.1942 11.4287 20.7213 11.4287ZM20.7213 21.8229C18.4356 21.8229 16.5784 19.9657 16.5784 17.68C16.5784 15.3943 18.4356 13.5371 20.7213 13.5371C23.007 13.5371 24.8642 15.3943 24.8642 17.68C24.8642 19.9657 23.012 21.8229 20.7213 21.8229Z" />\n' +
              '<path d="M20.7216 20.6917C22.366 20.6917 23.6991 19.3587 23.6991 17.7143C23.6991 16.0699 22.366 14.7368 20.7216 14.7368C19.0772 14.7368 17.7441 16.0699 17.7441 17.7143C17.7441 19.3587 19.0772 20.6917 20.7216 20.6917Z" />\n' +
              '</svg>\n',
          info: 'Claim your LQF tokens <br>every week '
        },
      ],
      flowViewClass: '',
      currentStepIndex: Number,
    }
  },
  methods: {

    getTime() {
      this.flowSteps[2].time = this.time1 ? moment.unix(this.time1).format('DD/MM/YY') : '';
      this.flowSteps[4].time = this.time2 ? moment.unix(this.time2).format('DD/MM/YY') : '';
    },

    getStepList() {
      let start = this.currentStep - 2;
      this.getTime();
      if (this.flowView === 'col') {
        this.currentStepIndex = this.currentStep - 1;
        return this.flowSteps;
      } else {
        if (this.currentStep === 1) {
          start = 0;
          this.currentStepIndex = 0;
        }
        else if (this.currentStep === this.flowSteps.length) {
          start = this.flowSteps.length - 3;
          this.currentStepIndex = 2;
        }
        else {
          this.currentStepIndex = 1;
        }
        return this.flowSteps.slice(start, start + 3);
      }
    },
    getStepClass(index) {
      if (index < this.currentStepIndex) {
        return 'done';
      }
      if (index === this.currentStepIndex) {
        return 'active'
      }
    },
  },
  mounted: function () {
    this.flowViewClass = 'flow-' + this.flowView;
  }

}
</script>

<style scoped lang="scss">

  .flow-step {
    font-size: 10px;
    line-height: 14px;
    color: $color-gray-700;
  }

  .flow-step-image {
    flex-grow: 0;
    flex-shrink: 0;
    fill: $color-gray-500;

    &.done {
      fill: $color-primary;
    }

    &.active {
      fill: $color-accent;
    }
  }

  .flow-step-info {
    flex-grow: 1;
  }

  .flow-col {
    width: 235px;
    padding: 16px;

    .flow-step {
      height: 48px;

      + .flow-step {
        border-top: 1px solid $color-gray-300;
      }
    }

    .flow-step-image {
      width: 34px;
    }

    .flow-step-info {
      padding: 0 16px 0 8px;
    }

  }

  .flow-row {
    display: flex;
    flex-direction: row;
    margin: 16px auto;
    justify-content: space-between;
    align-items: center;

    .flow-step {
      height: 52px;
      border: 1px solid $color-gray-300;
      border-radius: 5px;

      &.active {
        flex-grow: 1
      }

      &:not(.active) .flow-step-info {
        display: none;
      }

      @media (max-width: $screen-xs-max) {
        &:not(.active) {
          display: none !important;
        }
        &.active {
          background-color: $color-gray-100;
        }
      }
    }

    .flow-step-image {
      width: 55px;
    }

    .flow-step-status-icon {
      width: 43px;
      flex-grow: 0;
      flex-shrink: 0;
      border-left: 1px solid $color-gray-300;
      height: 100%;
    }

    .arrow {
      margin: auto 6px;

      &:last-of-type {
        display: none
      }
    }


  }

</style>
